import { PageBlueprint } from '@backstage/frontend-plugin-api';
import { Navigate } from 'react-router-dom';

export const rootRedirectPage = PageBlueprint.make({
  params: {
    path: '/',
    loader: async () => <Navigate to="/catalog" replace />,
  },
});
